import { ChevronDown } from 'lucide-react';
import { JSX } from 'react';

import MotionDropdown from '@motion/Dropdown';
import MotionInput from '@motion/Input';
import { DropdownMenuCheckboxItem } from '@shadCN/ui/dropdown-menu';
import { Table } from '@tanstack/react-table';

export interface Props<T> {
  table: Table<T>;
  searchPlaceholder: string;
  searchColumns: string[];
  globalFilter: string;
  setGlobalFilter: React.Dispatch<React.SetStateAction<string>>;
  toolbarButtons?: JSX.Element[];
}

export const DataTableHeader = <T,>({
  table,
  searchPlaceholder,
  searchColumns,
  globalFilter,
  setGlobalFilter,
  toolbarButtons,
}: Props<T>): JSX.Element => {
  return (
    <div className="flex justify-between items-center py-4">
      <MotionInput
        placeholder={searchPlaceholder}
        value={globalFilter}
        onChange={event => setGlobalFilter(event.target.value)}
        // value={
        //   (table.getColumn(searchColumns[0])?.getFilterValue() as string) ?? ''
        // }
        // onChange={event =>
        //   table.getColumn(searchColumns[0])?.setFilterValue(event.target.value)
        // }
        className="max-w-sm"
      />
      <div className="flex gap-2">
        {toolbarButtons && toolbarButtons}
        <MotionDropdown
          triggerButtonContent={
            <>
              Columns <ChevronDown />
            </>
          }
          dropdownContent={table
            .getAllColumns()
            .filter(column => column.getCanHide())
            .map(column => {
              return (
                <DropdownMenuCheckboxItem
                  key={column.id}
                  className="capitalize"
                  style={{ width: '100%' }}
                  checked={column.getIsVisible()}
                  onCheckedChange={value => column.toggleVisibility(!!value)}>
                  {column.id}
                </DropdownMenuCheckboxItem>
              );
            })}
        />
      </div>
    </div>
  );
};

export default DataTableHeader;
